export default __webpack_public_path__ + "static/media/soccer-field.441f0439.svg";